import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CaretDown } from '@phosphor-icons/react';
import { getCachedUser } from '../utils/auth';
import { useTranslation } from '../hooks/useTranslation';
import { getProfileNavSections, isProfileNavPathActive } from '../config/profileNav';

function SideLink({ to, ico, label, active, sub }) {
  return (
    <Link className={`ds-side-item${sub ? ' ds-side-item--sub' : ''}${active ? ' is-on' : ''}`} to={to}>
      {ico ? <span className="ds-side-item-ico" style={{ '--ico': `url(${ico})` }} aria-hidden /> : null}
      <span className="ds-side-item-label">{label}</span>
    </Link>
  );
}

export default function ProfileDsNav() {
  const location = useLocation();
  const { t } = useTranslation();
  const user = getCachedUser();
  const sections = getProfileNavSections(user, t);
  const [open, setOpen] = useState(() => {
    const next = {};
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    getProfileNavSections(getCachedUser()).forEach((section) => {
      section.items.forEach((item) => {
        if (item.hasDropdown && isProfileNavPathActive(item, path)) {
          next[item.id] = true;
        }
      });
    });
    return next;
  });

  const isSeller = Boolean(user?.is_seller);

  useEffect(() => {
    const next = {};
    getProfileNavSections({ is_seller: isSeller }).forEach((section) => {
      section.items.forEach((item) => {
        if (item.hasDropdown && isProfileNavPathActive(item, location.pathname)) {
          next[item.id] = true;
        }
      });
    });
    setOpen((prev) => ({ ...prev, ...next }));
  }, [location.pathname, isSeller]);

  return (
    <>
      {sections.map((section, index) => (
        <div key={section.id} className={index === 0 ? 'ds-side-items' : 'ds-acc'}>
          <p className="ds-acc-kicker">{section.label}</p>
          {section.items.map((item) => {
            if (!item.hasDropdown) {
              return (
                <SideLink
                  key={item.id}
                  to={item.path}
                  ico={item.iconPath}
                  label={item.label}
                  active={isProfileNavPathActive(item, location.pathname)}
                />
              );
            }
            const expanded = Boolean(open[item.id]);
            const parentOn = isProfileNavPathActive(item, location.pathname);
            return (
              <div key={item.id} className="ds-side-group">
                <button
                  type="button"
                  className={`ds-side-item${parentOn ? ' is-on' : ''}`}
                  aria-expanded={expanded}
                  onClick={() => setOpen((prev) => ({ ...prev, [item.id]: !prev[item.id] }))}
                >
                  <span className="ds-side-item-ico" style={{ '--ico': `url(${item.iconPath})` }} aria-hidden />
                  <span className="ds-side-item-label">{item.label}</span>
                  <CaretDown size={12} className={`ds-side-caret${expanded ? ' is-open' : ''}`} />
                </button>
                {expanded
                  ? item.subItems.map((sub) => (
                      <SideLink
                        key={sub.id}
                        to={sub.path}
                        label={sub.label}
                        sub
                        active={isProfileNavPathActive(sub, location.pathname)}
                      />
                    ))
                  : null}
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
}
